var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckTwoToneCircled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41239",
    "data-name": "Group 41239",
    transform: "translate(22275 7126)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_37042",
    "data-name": "Path 37042",
    transform: "translate(-22275 -7126)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,0A7,7,0,1,1,0,7H0A6.98,6.98,0,0,1,6.96,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.980321407318115 1.000245094299316 L 6.96325159072876 1.000274658203125 C 3.665841102600098 1.009675025939941 0.9908514022827148 3.699985504150391 1.000261306762695 7.000265121459961 C 1.000261306762695 10.30866527557373 3.691841125488281 13.00024509429932 7.000251293182373 13.00024509429932 C 10.30866146087646 13.00024509429932 13.00024127960205 10.30866527557373 13.00024127960205 7.000265121459961 C 13.00024127960205 3.691855430603027 10.30866146087646 1.000274658203125 6.997241497039795 1.000274658203125 L 6.980321407318115 1.000245094299316 M 6.980326652526855 0.0002450942993164062 C 6.986968994140625 0.0002450942993164062 6.993611335754395 0.0002546310424804688 7.000251293182373 0.000274658203125 C 10.86623191833496 0.000274658203125 14.00024127960205 3.134284973144531 14.00024127960205 7.000265121459961 C 14.00024127960205 10.86623477935791 10.86623191833496 14.00024509429932 7.000251293182373 14.00024509429932 C 3.134281158447266 14.00024509429932 0.0002613067626953125 10.86623477935791 0.0002613067626953125 7.000265121459961 C -0.01073837280273438 3.145255088806152 3.10542106628418 0.01127529144287109 6.96040153503418 0.000274658203125 C 6.967041492462158 0.0002546310424804688 6.973683834075928 0.0002450942993164062 6.980326652526855 0.0002450942993164062 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_7",
    "data-name": "Subtraction 7",
    d: "M7,14A7.008,7.008,0,0,1,0,7,6.981,6.981,0,0,1,6.961,0H7c.163,0,.331.006.5.018V6.2L5.907,7.8,4.256,6.165,3.123,7.279l2.784,2.764L7.5,8.45v5.533C7.329,13.995,7.162,14,7,14Z",
    transform: "translate(-22275 -7126)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_6",
    "data-name": "Subtraction 6",
    d: "M7.5,8.45V6.2L9.745,3.957l1.133,1.114L7.5,8.448Z",
    transform: "translate(-22275 -7126)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckTwoToneCircled);
export default __webpack_public_path__ + "static/media/check-two-tone-circled.4fe396443d2fa850dda80deb9fce258c.svg";
export { ForwardRef as ReactComponent };